import { PageTitle } from 'src/components/PageTitle';
import { CampaignsDataTable } from 'src/features/campaign/feature-campaign-list';

import { Icon } from 'src/components/Icon';
import { Button } from 'src/components/Button';
import { Group } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { links } from 'src/router/routes';

export const Campaigns = () => {
  const navigate = useNavigate();

  return (
    <div>
      <PageTitle title="My Campaigns" />
      <CampaignsDataTable />

      <Group justify="flex-end" align="center" mt="xl">
        <Button
          variant="filled"
          size="md"
          round={true}
          icon={<Icon name="add" />}
          onClick={() => navigate(links.campaignNew)}
        >
          ADD NEW
        </Button>
      </Group>
    </div>
  );
};
